/* eslint-disable @wyz/module/no-relative-import */
// import '@wyz/ui/styles';
import './assets/styles.scss';

import { createRoot } from 'react-dom/client';
import Main from './main';

const container = document.getElementById('root');
if (!container) {
  throw new Error('unable to find root element');
}
const root = createRoot(container);

root.render(<Main />);
